export default __webpack_public_path__ + "static/media/10.2427c02f.jpeg";